const state = {
  footer: {},
};

const getters = {
  get: state => state.footer,
};

const mutations = {
  SET(state, data) {
    state.footer = _.isPlainObject(data) ? data : {};
  },
};

const actions = {
  set({ commit }, data) {
    commit('SET', data)
  },
};

export default {
  namespaced: true,
  state,
  getters,
  mutations,
  actions,
};
